export default __webpack_public_path__ + "static/media/item3.60729c8e.jpg";